import { render } from "./BuyPlanModal.vue?vue&type=template&id=bb5f41ea&scoped=true"
import script from "./BuyPlanModal.vue?vue&type=script&lang=js"
export * from "./BuyPlanModal.vue?vue&type=script&lang=js"

import "./BuyPlanModal.vue?vue&type=style&index=0&id=bb5f41ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5f41ea"]])

export default __exports__